<script setup>
// import CheckoutForm from '../CheckoutForm.vue';
// import CouponForm from '../CouponForm.vue';
import CheckoutForm from './CheckoutForm.vue';
import CouponForm from './CouponForm.vue';
import ArgumentsBeforeSubscription from '@/Components/Partners/Meditbe/ArgumentsBeforeSubscription.vue';
import ReviewsBeforeSubscription from '@/Components/Partners/Meditbe/ReviewsBeforeSubscription.vue';

import ImgVisual from '@/Images/ImgVisual.vue';
import { ref, toRefs } from 'vue';

import { trans, transChoice } from 'laravel-vue-i18n';

const props = defineProps({
    debug: { type: Boolean, default: false },
    //
    entitlement_id: { type: String },
    entitlement_lookup_key: { type: String },
    offering: { type: Object, },
    success_url: { type: String },
    cancel_url: { type: String },
    coupon: { type: Object },
    has_stripe_coupon: { type: Boolean, default: false },
    has_local_coupon: { type: Boolean, default: false },
    show_stripe_offers: { type: Boolean, default: false },
    //
    layout: { type: Object, default: {} },
    partner_slug: { type: String, default: '' },
    step: { type: Number, default: 1 },
    updateSubscription: { type: Function },
    reloadOffering: { type: Function },
    subscription: { type: Object },
    //
    route_checkout: { type: String },
    route_coupon: { type: String },
    route_coupon_validate: { type: String },
});

const getImageUrl = (link) => {
    return new URL(link, import.meta.url).href
}
const layout_left_img_src = props.layout && props.layout.left && props.layout.left.img_src
    ? getImageUrl(props.layout.left.img_src)
    : null;

const { subscription } = toRefs(props);
const emit = defineEmits(['updateSubscription', 'reloadOffering']);
const updateSubscription = (prop, value) => {
    emit('updateSubscription', prop, value)
}
const reloadOffering = (code, callback) => {
    emit('reloadOffering', code, callback)
}

const childCheckout = ref(null);
const childCoupon = ref(null);

defineExpose({
    childCheckout,
    childCoupon
});
</script>

<template>
    <div :class="{ 'flex flex-wrap -mx-3': layout && layout.left }">
        <div v-if="layout && layout.left" class="w-full md:w-1/3 order-2 md:order-1 px-3 mb-6 md:mb-0"
        :class="[`
            bg-[${layout.colors.secondary_color}] 
            dark:bg-[${layout.colors.background}]
            text-[${layout.colors.txt_default}]
            dark:text-white
            `]">
            <div class="px-4 pt-12 pb-10 text-white">

                <div class="mt-0 leading-tight text-lg font-bold">
                    {{ layout.left.title }}
                </div>
                <div class="my-6">
                    {{ layout.left.content }}
                </div>

                <div v-if="layout_left_img_src" class="mt-8">
                    <img :src="layout_left_img_src" />
                </div>

            </div>
        </div>
        <div :class="{ 'w-full md:w-2/3 order-1 md:order-2 px-3 text-center': layout && layout.left }">

            <ImgVisual v-if="!show_stripe_offers" class="mx-auto" />

            <div class="pb-8">
                <Transition>
                    <div v-show="debug || !show_stripe_offers && (has_local_coupon || has_stripe_coupon || !subscription.app_user_coupon_stripe)">
                        <label for="coupon">
                            <div class="my-6 text-center text-2xl font-bold">
                                {{ trans('Saisissez votre code') }}
                            </div>
                        </label>

                        <CouponForm ref="childCoupon" :partner="partner_slug" :route_submit="route_coupon_validate" :entitlement_lookup_key="entitlement_lookup_key" :entitlement_id="entitlement_id" :subscription="subscription" @updateSubscription="updateSubscription" @reloadOffering="reloadOffering" :offering="offering" :success_url="success_url" :cancel_url="cancel_url" :coupon="coupon" :has_stripe_coupon="has_stripe_coupon" :has_local_coupon="has_local_coupon" :payment_label="layout.payment_label" :payment_labels="layout.payment_labels" :debug="debug" />
                    </div>
                </Transition>
                <Transition>
                    <div class="flex flex-col gap-4 sm:gap-8" v-show="debug || step > 0 && (show_stripe_offers || (!has_stripe_coupon && subscription.app_user_coupon_stripe))">
                        <template v-if="show_stripe_offers">
                            <h2 class="text-center sm:text-2xl font-bold order-1">
                                <!-- Accéder à l'offre complète en illimité -->
                                {{ trans('partners.subscriptions.title') }}
                            </h2>
                            <div class="re-assurance order-3 sm:order-2 px-6 sm:px-0">

                                <div class="flex flex-col sm:flex-row gap-4 mb-6 text-sm max-w-4xl mx-auto">
                                    <div class="flex flex-col gap-4 sm:w-1/2">
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                <!-- Accompagné par un expert français en Méditation de Pleine Conscience -->
                                                {{ trans('partners.subscriptions.args.0') }}
                                            </span>
                                        </div>
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                {{ trans('partners.subscriptions.args.1') }}
                                            </span>
                                        </div>
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                <!-- Des outils spécialement conçus pour réguler son stress -->
                                                {{ trans('partners.subscriptions.args.2') }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-4 sm:w-1/2">
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                <!-- Des programmes d'initiation à la Sophrologie et des outils de Cohérence Cardiaque -->
                                                {{ trans('partners.subscriptions.args.3') }}
                                            </span>
                                        </div>
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                <!-- Retrouvez le sommeil et la sérénité grâce à nos nombreux programmes dédiés -->
                                                {{ trans('partners.subscriptions.args.4') }}
                                            </span>
                                        </div>
                                        <div class="flex gap-2">
                                            <svg class="shrink-0 w-5 h-5" :class="`stroke-[${layout.colors.primary_color}]`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                                <polyline points="26.41 8.36 13.13 21.64 3.59 12.11" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="5" />
                                            </svg>
                                            <span>
                                                <!-- Relaxez-vous avec nos musiques et nos sons immersifs -->
                                                {{ trans('partners.subscriptions.args.5') }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <h2 class="my-6 text-center text-2xl font-bold order-0 sm:order-0">
                                <!-- Votre code est valide ! -->
                                {{ trans('Votre code est valide !') }}
                            </h2>
                        </template>
                        <div class="order-2 sm:order-3 mb-4">
                            <CheckoutForm ref="childCheckout" :route_checkout="route_checkout" :subscription="subscription" @updateSubscription="updateSubscription" @reloadOffering="reloadOffering" :offering="offering" :success_url="success_url" :cancel_url="cancel_url" :has_stripe_coupon="has_stripe_coupon" :has_local_coupon="has_local_coupon" :show_stripe_offers="show_stripe_offers" :payment_labels="layout.payment_labels" :layout="layout" :debug="debug" />
                        </div>
                        <div class="order-4 px-6 sm:px-0">
                            <ArgumentsBeforeSubscription />
                        </div>
                        <div class="order-4 px-6 sm:px-0">
                            <ReviewsBeforeSubscription />
                        </div>
                    </div>
                </Transition>
            </div>

            <div class="mt-24 mb-6 text-sm text-left ml-4">
                <div v-if="layout && typeof layout.footer != 'undefined'" class="hidden md:block">
                    {{ trans(layout.footer) }}
                </div>
            </div>
        </div>
    </div>
    <div v-if="layout && typeof layout.footer != 'undefined'" class="md:hidden my-24 text-sm text-left">
        {{ trans(layout.footer) }}
    </div>
</template>